// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1YWMi","buttons":"PendingPaymentAlert_buttons__1l126"};